import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {
	Link
} from 'react-router-dom';
import Loader from '../../components/Loader';
import axiosInstance from '../../utils/api';

type Props = {}

interface ComponentInterface {
    id: string;
    name: string;
    type: string;
    supplier: string;
    category: string;
    remark: string;
}

const ComponentList = (props: Props) => {
    const title = "Component"
    const [loading, setLoading] = useState(false)
    const [components, setComponents] = useState<Array<ComponentInterface>>([])

    useEffect(() => {
        getDateList()
    }, [])

    function getDateList() {
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/operations/v1/component").then(res=>{
            setLoading(false)
            console.log(res.data)
            setComponents(res.data)
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }

    function handleDelete(id:string) {
        if (!window.confirm("Are you sure you want to delete record?")) return
        setLoading(true)
        axiosInstance.delete(`https://api.cl-ds.com/internal/operations/v1/component/${id}/`).then(res=>{
            setLoading(false)
            console.log(11, res)
            alert(res.data.message)
            getDateList()
        }).catch(err=>{
            setLoading(false)
            console.log(123, err)
        })
    }
    

    return (
            <div className="col-12">
            {loading && ( <Loader/> )}

                <div className="card">
                    <div className="card-body">
                        <div className="row px-2" style={{display:"grid", gridTemplateColumns:"1fr 1fr"}}>
                            <h5 className="card-title">{title} List</h5>
                            <div style={{display:"flex", justifyContent:"end", alignSelf:"center"}}>
                                
                                <Link to="/component/add" >
                                    <button type="button" className="btn btn-outline-info">Create</button>
                                </Link>
                            </div>

                        </div>


                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Category</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Supplier</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {components.map( (component, index) => {

                                    return (
                                        <tr key={index}>
                                            <th scope="row">{component.name}</th>
                                            <td>{component.category}</td>
                                            <td>{component.type}</td>
                                            <td>{component.supplier}</td>
                                            <td>
                                                <Link to={`/component/edit/${component.id}`} >
                                                    <button type="button" className="btn btn-outline-info"><i className="bi bi-pencil"></i></button>
                                                </Link>
                                                <button type="button" className="btn btn-outline-danger mx-1" onClick={()=>{handleDelete(component.id.toString())}}><i className="bi bi-trash"></i></button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    

                    </div>
                </div>

            </div>

    )
}

export default ComponentList